import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=4ef14462&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=4ef14462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef14462",
  null
  
)

export default component.exports